export const CREATOR_UNKNOWN = 'unknown' as const;
